module.exports = __webpack_public_path__ + "img/3.052b420a.jpg";